import { blogPathTranslator } from "../../helpers/BlogPathTranslator"

export default function PostLinkTransformer(
  path,
  languageSlug,
  defaultLanguage,
  languagesEnabled
) {
  if (!path) return null

  const languagesEnabledRegExp = languagesEnabled.map(
    l => new RegExp(l.replace(`_`, `-`))
  )

  const basePath = languageSlug === defaultLanguage ? `` : `/${languageSlug}`

  const blogUriRoot = blogPathTranslator(languageSlug)

  let filteredSlug = `/${blogUriRoot}${path}`

  let matchedLanguage = languagesEnabledRegExp.find(re => re.test(filteredSlug))
  if (matchedLanguage)
    filteredSlug = filteredSlug.replace(
      `-${matchedLanguage.source.replace(`/`, ``)}`,
      ``
    )

  if (filteredSlug.startsWith(basePath))
    return filteredSlug.slice(basePath.length)

  return filteredSlug
}
